<template>
  <div class="rightPage" >

    <el-row>
      <el-col :span="20">
        <el-row v-show="tableData && tableData.length > 0"  @click="openViewer">
          <el-col :span="24">
            <canvas id="myCanvas1" width="1000" height="1000"></canvas>
          </el-col>
        </el-row>
        <el-row v-show="tableData && tableData.length > 1"  @click="openViewer">
          <el-col :span="24">
            <canvas id="myCanvas2" width="1000" height="1000"></canvas>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="4">
        <div class="right-part" :style="myStyle">
          <el-row class="base-info" >
            <el-col :span="24">
              基本信息
            </el-col>
            <el-col :span="24" style="white-space:nowrap;">
              批次号：{{scanPre.batch_id}}
            </el-col>
            <el-col :span="24">
              序号：{{scanPre.seq}}
            </el-col>
            <el-col :span="24">
              页码：{{scanPre.page_no}}
            </el-col>
            <el-col :span="24">
              状态：<span :class="scanPre.status=='ZC'?'': 'status-error'">{{formatStatus(scanPre.status)}}</span>
            </el-col>
            <el-col :span="24">
              学号：{{scanPre.student_no}}
            </el-col>
            <el-col :span="24">
              姓名：{{scanPre.student_name}}
            </el-col>
            <el-col :span="24" v-if="scanPre.paper_ab!=null">
              AB卷：{{scanPre.paper_ab}}卷
            </el-col>
            <el-col :span="24" style="color: #F6F7FC;white-space:nowrap;">
              id：{{scanPre.id}}
            </el-col>
            <el-col :span="24" style="color: #F6F7FC;white-space:nowrap;">
              same id：{{scanPre.same_exam_id}}
            </el-col>
          </el-row>
          <el-row style="text-align: center" class="base-info">
            <el-col :span="24">
              基本操作
            </el-col>

            <el-col :span="24" style="margin-top: 15px;">
              <el-button type="primary" size="mini" @click="openViewer">查看原卷</el-button>
            </el-col>
            <el-col :span="24" style="margin-top: 15px;">
              <el-button type="primary" size="mini" @click='showChangeExamDialog()'>更换考试</el-button>
            </el-col>
            <el-col :span="24" style="margin-top: 15px;">
              <el-button type="primary" size="mini" @click='changeStudentNo()'>更改学号</el-button>
            </el-col>

          </el-row>
          <el-row style="text-align: center" class="base-info">
            <el-col :span="24" style="color: red; ">
              危险操作
            </el-col>
            <el-col :span="24" style="margin-top: 15px;">
              <el-button type="danger" size="mini" @click='doDeleteScanFile()'>删除</el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <studentBox title="选择学生" :scanFileId="scanPre.id" ref="studentBox" @ok="selectStudent" :exceptType="scanPre.status" :updateStatus="'C1'"
                :examId="scanPre.exam_id" :searchText="null" :sameExamId="scanPre.same_exam_id" :top="200" :left="300" :right="0"></studentBox>

    <changeExamDialog ref="changeExamDialog" :scanPre="scanPre" @ok="selectChangeExam"></changeExamDialog>
    <el-image-viewer v-if="showViewer && examImageList" :on-close="closeViewer" :url-list="examImageList" />
  </div>

</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex';
  import XEUtils from 'xe-utils'
  import * as simpleApi from "request/simple";
  import * as mUtils from '@/utils/mUtils'
  import studentBox from "./studentBox";
  import changeExamDialog from "./changeExamDialog"
  import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

  export default {
    name: 'rightPage',
    computed: {
      ...mapState({
        userInfo: state => state.user.userInfo,
      }),
    },
    props: {
      info: {
        type: Object
      }
    },
    components:{
      studentBox, changeExamDialog, ElImageViewer
    },
    watch: {
      info: {
        deep: true, immediate:true,
        handler(n, o){
          console.log(n)
          if(n){
            this.scanPre = n;
            this.loadExamPages();
          }
        }
      },
    },
    data() {
      return {
        scanPre: null, scanList: [], searchText: '', showViewer: false,
        url: '', id: null, scanFileId: null, examId: null, myStyle: null,
        theDialogVisible: true, loading:false, tableData: [], examImageList: [],
        getPre: null, imgInfo: null, pointList:[], cardInfo: null, selPoint: null,
        searchForm:{ pageNo: 1, pageSize: 50, totalCount: 0, searchText: null},
        percent: {
                "P2": [[0.4341085271317829416663750, 0.748062015503875991667], [0.748062015503875991667, 1]], 
                // "P2": [[0.2, 0.6], [0.6, 1]], 
                // "PD2": [[0.37184693, 0.689799434], [0.689799434, 1]],
                "PD2": [[0.433821418333, 0.73459296629632963], [0.70141708708336667, 1]],
                "P3": [[0.353982300884955750000, 0.5693215339233038333333333],
                 [0.5693215339233038333333333, 0.7846607669616519166666666], 
                 [0.7846607669616519166666666, 1]],
                // 0.8
                // "P4": [[0.2857142857142857000000, 0.4595238095238095133333333], [0.4595238095238095133333333,0.6333333333333333266666666], [0.6333333333333333266666666, 0.8071428571428571399999999], [0.8071428571428571399999999, 1]],
                // 0.75
                "P4": [[0.2857142857142857000000, 0.46428571428571427500000000],
                [0.46428571428571427500000000,0.64285714285714285000000000], 
                [0.64285714285714285000000000, 0.82142857142857142500000000], 
                [0.82142857142857142500000000, 1]],
                
                "P5": [[0.2395209580838323500000, 0.39161676646706588000000000], 
                [0.39161676646706588000000000, 0.54371257485029941000000000],
                 [0.54371257485029941000000000, 0.69580838323353294000000000],
                  [0.69580838323353294000000000, 0.84790419161676647000000000], 
                  [0.84790419161676647000000000 , 1]],
                  
                "P6": [[0.2061855670103092750000, 0.33848797250859106250000000], 
                [0.33848797250859106250000000, 0.47079037800687285000000000],
                 [0.47079037800687285000000000, 0.60309278350515463750000000], 
                 [0.60309278350515463750000000, 0.73539518900343642500000000], 
                 [0.73539518900343642500000000,0.86769759450171821250000000], 
                 [0.86769759450171821250000000, 1]],


                "P7": [[0.1809954751131221875000, 0.29799612152553330357142857],
                 [0.29799612152553330357142857, 0.41499676793794441964285714],
                  [0.41499676793794441964285714,0.53199741435035553571428571],
                   [0.53199741435035553571428571, 0.64899806076276665178571428],
                    [0.64899806076276665178571428,  0.76599870717517776785714285],
                     [0.76599870717517776785714285,  0.88299935358758888392857142],
                      [0.88299935358758888392857142, 1]],


                "P8": [[0.1612903225806451625000, 0.26612903225806451718750000],
                 [0.26612903225806451718750000, 0.37096774193548387187500000],
                  [0.37096774193548387187500000,  0.47580645161290322656250000],
                   [0.47580645161290322656250000,  0.58064516129032258125000000],
                    [0.58064516129032258125000000,  0.68548387096774193593750000],
                     [0.68548387096774193593750000,  0.79032258064516129062500000],
                      [0.79032258064516129062500000, 0.89516129032258064531250000],
                       [0.89516129032258064531250000, 1]],


                       
                "P9": [[0.1454545454545454500000,0.24040404040404040000000000],
                 [0.24040404040404040000000000 ,  0.33535353535353535000000000],
                  [0.33535353535353535000000000, 0.43030303030303030000000000],
                   [0.43030303030303030000000000,  0.52525252525252525000000000],
                    [0.52525252525252525000000000,  0.62020202020202020000000000],
                     [0.62020202020202020000000000, 0.71515151515151515000000000],
                      [0.71515151515151515000000000,  0.81010101010101010000000000],
                       [0.81010101010101010000000000,  0.90505050505050505000000000],
                        [0.90505050505050505000000000, 1]],


                "P10": [[0.1324503311258278125000,  0.21920529801324503125000000],
                  [0.21920529801324503125000000, 0.30596026490066225000000000], //B
                  [0.30596026490066225000000000, 0.39271523178807946875000000],
                  [0.39271523178807946875000000,  0.47947019867549668750000000], //D
                  [0.47947019867549668750000000, 0.56622516556291390625000000],
                  [0.56622516556291390625000000,  0.65298013245033112500000000], //F
                  [0.65298013245033112500000000,  0.73973509933774834375000000],

                  [0.73973509933774834375000000,  0.843841059602649006250000000], //H
                  [0.843841059602649006250000000,  0.91324503311258278125000000],
                  [0.91324503311258278125000000, 1]],

                //   [0.73973509933774834375000000,  0.82649006622516556250000000], //H
                //   [0.82649006622516556250000000,  0.91324503311258278125000000],
                //   [0.91324503311258278125000000, 1]],



              "P11": [[0.121580547112462000000, 0.2014368610113290909090909], 
              [0.2014368610113290909090909, 0.2812931749101961818181818],
               [0.2812931749101961818181818, 0.3611494888090632727272727], 
               [0.3611494888090632727272727,0.4410058027079303636363636], 
               [0.4410058027079303636363636, 0.5208621166067974545454545], 
               [0.5208621166067974545454545, 0.6007184305056645454545454 ],
                [0.6007184305056645454545454,  0.6805747444045316363636363], 

                [0.6805747444045316363636363, 0.77640232108317214545454538], 
                [0.77640232108317214545454538,  0.84028737220226581818181810], 
                [0.84028737220226581818181810,  0.916150870406189554545454455], 
                [0.916150870406189554545454455, 1]],

                // [0.6805747444045316363636363, 0.7604310583033987272727272], 
                // [0.7604310583033987272727272,  0.8402873722022658181818181], 
                // [0.8402873722022658181818181,  0.9201436861011329090909090], 
                // [0.9201436861011329090909090, 1]],



              "P12": [[0.112359550561797750000, 0.1863295880149812708333333],  //A
                [0.1863295880149812708333333, 0.2602996254681647916666666], //B
                [0.2602996254681647916666666,  0.3342696629213483124999999],
                [0.3342696629213483124999999,  0.4082397003745318333333332], //D
                [0.4082397003745318333333332,  0.4822097378277153541666665],
                [0.4822097378277153541666665, 0.5561797752808988749999998], //F
                [0.5561797752808988749999998,  0.6301498127340823958333331],

                [0.6301498127340823958333331,  0.71891385767790262083333306], //H
                [0.71891385767790262083333306,  0.77808988764044943749999970],
                [0.77808988764044943749999970,  0.848361423220973782291666335], //J
                [0.848361423220973782291666335,  0.922331460674157303124999635],
                [0.922331460674157303124999635, 1]],

                // [0.6301498127340823958333331,  0.7041198501872659166666664], //H
                // [0.7041198501872659166666664,  0.7780898876404494374999997],
                // [0.7780898876404494374999997,  0.8520599250936329583333330], //J
                // [0.8520599250936329583333330,  0.9260299625468164791666663],
                // [0.9260299625468164791666663, 1]],


                "P13": [[0.104438642297650125000, 0.1733279775055231923076923],  //A
                [0.1733279775055231923076923,  0.2422173127133962596153846], //B
                [0.2422173127133962596153846,  0.3111066479212693269230769],
                [0.3111066479212693269230769, 0.3799959831291423942307692], //D
                [0.3799959831291423942307692,  0.4488853183370154615384615],
                [0.4488853183370154615384615,  0.5177746535448885288461538], //F
                [0.5177746535448885288461538,  0.5866639887527615961538461],

                [0.5866639887527615961538461, 0.66933119100220927692307686], //H
                [0.66933119100220927692307686,  0.72444265916850773076923070],
                [0.72444265916850773076923070,  0.789887527615987144711538385], //J
                [0.789887527615987144711538385, 0.858776862823860212019230685],
                [0.858776862823860212019230685,   0.927666198031733279326922985],
                [0.927666198031733279326922985, 1]],

                // [0.5866639887527615961538461, 0.6555533239606346634615384], //H
                // [0.6555533239606346634615384,  0.7244426591685077307692307],
                // [0.7244426591685077307692307,  0.7933319943763807980769230], //J
                // [0.7933319943763807980769230, 0.8622213295842538653846153],
                // [0.8622213295842538653846153,  0.9311106647921269326923076],
                // [0.9311106647921269326923076, 1]],



                "P14": [[0.0975609756097561000000,  0.16202090592334495000000000],  //A
                [0.16202090592334495000000000, 0.22648083623693380000000000 ], //B
                [0.22648083623693380000000000,  0.29094076655052265000000000],
                [0.29094076655052265000000000,  0.35540069686411150000000000], //D
                [0.35540069686411150000000000, 0.41986062717770035000000000 ],
                [0.41986062717770035000000000,  0.48432055749128920000000000], //F
                [0.48432055749128920000000000,  0.54878048780487805000000000],
                

                [0.54878048780487805000000000,  0.626132404181184670000000000], //H
                [0.626132404181184670000000000,  0.67770034843205575000000000],
                [0.67770034843205575000000000,  0.7389372822299651575000000000], //J
                [0.7389372822299651575000000000,  0.8033972125435540075000000000],
                [0.8033972125435540075000000000,   0.8678571428571428575000000000],
                [0.8678571428571428575000000000,  0.9323170731707317075000000000],
                [0.9323170731707317075000000000, 1]],

                // [0.54878048780487805000000000,  0.61324041811846690000000000], //H
                // [0.61324041811846690000000000,  0.67770034843205575000000000],
                // [0.67770034843205575000000000,  0.74216027874564460000000000], //J
                // [0.74216027874564460000000000,  0.80662020905923345000000000],
                // [0.80662020905923345000000000,  0.87108013937282230000000000],
                // [0.87108013937282230000000000,  0.93554006968641115000000000],
                // [0.93554006968641115000000000, 1]],


                "P15": [[0.0915331807780320375000, 0.15209763539282990166666667],  //A
                [0.15209763539282990166666667,  0.21266209000762776583333334], //B
                [0.21266209000762776583333334,  0.27322654462242563000000001],
                [0.27322654462242563000000001,  0.33379099923722349416666668], //D
                [0.33379099923722349416666668,  0.39435545385202135833333335],
                [0.39435545385202135833333335,  0.45491990846681922250000002], //F
                [0.45491990846681922250000002, 0.51548436308161708666666669 ],
                
                [0.51548436308161708666666669,  0.588161708619374523666666694], //H
                [0.588161708619374523666666694,  0.63661327231121281500000003],
                [0.63661327231121281500000003, 0.691121281464530892750000033 ], //J
                [0.691121281464530892750000033, 0.751685736079328756916666703 ],
                [0.751685736079328756916666703, 0.812250190694126621083333373],
                [0.812250190694126621083333373, 0.872814645308924485250000043],
                [0.872814645308924485250000043, 0.933379099923722349416666713],
                [0.933379099923722349416666713, 1]],

                // [0.51548436308161708666666669,  0.57604881769641495083333336], //H
                // [0.57604881769641495083333336,  0.63661327231121281500000003],
                // [0.63661327231121281500000003, 0.69717772692601067916666670 ], //J
                // [0.69717772692601067916666670,  0.75774218154080854333333337],
                // [0.75774218154080854333333337,  0.81830663615560640750000004],
                // [0.81830663615560640750000004, 0.87887109077040427166666671],
                // [0.87887109077040427166666671, 0.93943554538520213583333338 ],
                // [0.93943554538520213583333338, 1]],
                
            },
      }
    },
    mounted() {
      let myHeight = document.documentElement.clientHeight ;
      this.myStyle = {height: (myHeight-200) + 'px'};

    },
    destroyed() {

    },
    methods: {

      formatStatus(status){
        return mUtils.examStatus(status);
      },
      loadExamPages(){
        let that = this;
        console.log("loadExamPages")
        let search = { licenceId: this.userInfo.licenceId, sameExamId: this.scanPre.same_exam_id};
        let param = { controllerName: 'scan/scanPre', methodName: '/getBySameExamId',  param: search};
        return simpleApi.list(param).then(({result: {code, data}}) =>  {
          console.log("loadExamPages", data)
          this.examImageList = [];
          if (data) {
            this.tableData = data;
            for (let i=0; i<data.length; i++){
              let d = data[i];
              if(d.ossFullName != null){
                this.examImageList.push(d.ossFullName);
              }
              this.loadCanvas(d);
            }

          }
        }).catch((error) => {
          console.log("error")
        });
      },
      loadCanvas(d){
        let that = this;
        let pageNo = d.pageNo;
        this.$nextTick(() => {
          var canvas = document.getElementById("myCanvas"+pageNo);
          let tt = document.documentElement.clientWidth / 5 *3;
          console.log("loadCanvas pageNo", pageNo, canvas)
          if(canvas.getContext){
            let ctx = canvas.getContext('2d');
            let img = new Image();
            img.src = mUtils.urlAddTimestamp(d.cutOssFullName);
            img.onload = function () {
              let scale = 1;
              if(this.width > tt||this.height > tt){
                if(this.width > this.height) scale = tt/this.width;
                if(this.height > this.width) scale = tt/this.height;
                ctx.width = this.width * scale;
                ctx.height = this.height * scale;
                canvas.width = ctx.width;
                canvas.height = ctx.height;
                // console.log("ctx", ctx.width, ctx.height, scale)
                ctx.drawImage(this, 0, 0, ctx.width, ctx.height);
                that.cardInfoAndImage(ctx, d);
              }
            }
          }
        });

      },
      cardInfoAndImage(ctx, d){
        try{
          // console.log("cardInfoAndImage", d)
          if(d.cardInfo){
            let cardInfo = JSON.parse(d.cardInfo);
            let index = 0;
            let width = ctx.width;
            let height = ctx.height;
            let client = document.getElementById("myCanvas"+d.pageNo).getBoundingClientRect();
            console.log("pageNo", d.pageNo, client);
            if(cardInfo && cardInfo.length > 0){
              for (let i=0; i<cardInfo[d.pageNo-1].sections.length; i++){
                let sect = cardInfo[d.pageNo-1].sections[i];
                for (let j=0; j<sect.list.length; j++){
                  if(sect.list[j].type == "Object"){
                    let pos = sect.list[j].position;
                    let branchs = sect.list[j].branch;
                    // console.log('pos', pos, branchs)
                    for (let k=0; k<branchs.length; k++){
                      let branch = branchs[k];
                      ctx.strokeStyle = 'blue';
                      ctx.lineWidth = 1;
                      let posWidth = pos.width_scale*width;
                      let posHeight = pos.height_scale*height;
                      let x = pos.left_begin*width + posWidth * branch.left_begin;
                      let y = pos.top_begin*height + posHeight * branch.top_begin;
                      let w = posWidth*branch.width_ratio;
                      let h = posHeight*branch.height_ratio;
                      if(d.pageNo==2) console.log('branch...', k, d.pageNo, branch);
                      if("stu_answer" in branch){
                        console.log('branch', k, d.pageNo, branch.stu_answer);
                        ctx.fillStyle = 'red'
                        // ctx.font = 'normal bold 12px Arial,sans-serif '
                        let stu_anw = branch.stu_answer;
                        let numList = branch.numList;
                        let a_h = h / stu_anw.length;
                        for (let m=0; m<stu_anw.length; m++){
                          let a_x = x+5;
                          let a_y = y+10 + m * a_h;
                          ctx.fillText(numList[m] + "."+stu_anw[m], a_x, a_y)
                        }
                      }
                      ctx.strokeRect(x, y, w, h);
                      // console.log('draw', d.pageNo, branch, pos);
                    }
                    this.drawChoose(ctx, height, width, pos, branchs);
                  }

                  index = index + 1;
                }
              }
            }
          }
        }catch (e) {
          console.log("error", e)
        }
      },
      drawChoose(ctx, height, width, pos, branchs){
        // console.log("drawChoose", height, width, pos, branchs)
        let posLeft = pos.left_begin*width;
        let posTop = pos.top_begin*height;
        let posWidth = pos.width_scale*width;
        let posHeight = pos.height_scale*height;
        let row_x = 0, row_y = 0, x = 0, y = 0;
        for(let i=0; i< branchs.length; i++){
          let branch = branchs[i] ;
          let b_t = posHeight * branch.top_begin+posTop;
          let b_l = posWidth * branch.left_begin+posLeft;
          let b_h = posHeight * branch.height_ratio;
          let b_w = posWidth * branch.width_ratio;
          let pos = branch.position;
          let perPre = (branch.subAreaTopicType=="Judge")?"PD":"P";
          let ixList = branch.ixList;
          let ixY = b_t + b_h*2.5/pos.height;
          let tiH = b_h*5/pos.height;
          let percent = this.percent[perPre+branch.chooseCount];
          for (let j=0; j<ixList.length; j++){
            let iY = ixY + j*tiH;
            for (let k=0; k<percent.length; k++){
              let tiX = b_l+b_w*percent[k][0];
              let tiXEnd = b_l+b_w*percent[k][1];
              let tiW = tiXEnd-tiX;
              let tiGe = tiW/4;
              let tiHGe = tiH/4;
              // ctx.beginPath();ctx.rect(tiX+tiGe, iY, tiW-tiGe*2, tiH-tiHGe);ctx.stroke();
              // console.log("", j, k, tiX, tiGe, iY, tiH, tiW, tiW-tiGe, tiH-tiHGe )
              ctx.beginPath();
              ctx.rect(tiX+tiGe, iY, tiW *0.65, tiH-tiHGe );
              ctx.stroke();
            }
          }

          row_x = row_x + b_w;
        }

      },
      showChangeExamDialog(){
        this.$refs.changeExamDialog.showDialog();
      },
      selectChangeExam(){
        this.$refs.changeExamDialog.hideDialog();
        this.$message({ type: 'success', message: '更新成功!'});
        this.$emit('changeExam');
      },
      changeStudentNo(){
        this.$refs.studentBox.showDialog();
      },
      selectStudent(sameExamId){
        this.$refs.studentBox.hideDialog();
        this.$message({ type: 'success', message: '更新成功!'});
      },
      changePageNo(){
        let that = this;
        let status = this.scanPre.status;
        this.$confirm('本操作应用于试卷倒反扫描，将改变页码顺序，是否确定操作?', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
        }).then(() => {

          let param = { controllerName: 'scan/scanPre', methodName: '/changePageNo', param: { sameExamId: this.scanPre.same_exam_id, status: '01' }};
          simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
            if (code == 0) {
              that.$message({ type: 'success', message: '变更成功!'});
              this.$emit('ok', status);
            }
          });
        }).catch(() => {

        });
      },
      openViewer(){
        console.log("openViewer")
        this.showViewer = true;
      },
      closeViewer(){
        this.showViewer = false;
      },
      doDeleteScanFile(){
        let that = this;
        let status = this.scanPre.status;
        this.$confirm('将删除此试卷?', '提示', {
          confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'
        }).then(() => {

          let param = { controllerName: 'scan/scanPre', methodName: '/deleteBySameExamId', param: { sameExamId: this.scanPre.same_exam_id }};
          simpleApi.post(param).then(({ result: { code, data}, sysCode}) =>  {
            if (code == 0) {
              that.$message({ type: 'success', message: '删除成功!'});
              this.$emit('ok', status);
            }
          });
        }).catch(() => {

        });
      },
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">

  .rightPage {

    .status-error{
      color: red;
    }
    .el-form-item__label {
      font-size: 16px;
      color: black;
    }
    .right-part {
      padding: 10px;
      // border: 1px solid rgba(203, 202, 202, 0.71);
      // border-bottom-left-radius: 10px;
      // border-bottom-right-radius: 10px;
      // border-top-left-radius: 10px;
      // border-top-right-radius: 10px;

      .data-row{
        margin-bottom: 10px;
      }
      .student-no-lost {
        text-align: left;
      }
      .base-info {
        text-align: left;
        // margin-top: 10px;
        // padding: 5px;
        // border: 1px solid rgba(203, 202, 202, 0.71);
        // border-bottom-left-radius: 10px;
        // border-bottom-right-radius: 10px;
        // border-top-left-radius: 10px;
        // border-top-right-radius: 10px;
      }
    }

  }




</style>
